import { createSlice } from '@reduxjs/toolkit';

const defaultActiveItem = {
  discountType: 'percent',
  value: 15,
  promoCode: '',
  title: '',
  description: '',
  picture: '',
};

const defaultCta = {
  label: 'Shop now',
  action: 'copy',
  target: '',
};

const defaultTrigger = {
  type: 'delay',
  delaySec: 3,
  scrollPct: 50,
};

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    // offer source
    sourceMode: 'new',
    discountId: null,
    activeItem: { ...defaultActiveItem },

    // copywriting
    headline: '',
    subtitle: '',
    cta: { ...defaultCta },

    // display (Design tab)
    format: 'bar',
    position: 'bottom',
    theme: 'dark',
    radius: 16,

    // triggers
    trigger: { ...defaultTrigger },
    frequency: 'session',
    frequencyDays: 7,
    newVisitorsOnly: false,
    countdown: false,
  },
  blockDesign: {
    layout: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const discountBlockSlice = createSlice({
  name: 'discountBlock',
  initialState,
  reducers: {
    discountBlockStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent = {}, blockDesign = {} } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        sourceMode: blockContent.sourceMode ?? 'new',
        discountId: blockContent.discountId ?? null,
        activeItem: { ...defaultActiveItem, ...(blockContent.activeItem ?? {}) },

        headline: blockContent.headline ?? '',
        subtitle: blockContent.subtitle ?? '',
        cta: { ...defaultCta, ...(blockContent.cta ?? {}) },

        format: blockContent.format ?? 'bar',
        position: blockContent.position ?? 'bottom',
        theme: blockContent.theme ?? 'dark',
        radius: blockContent.radius ?? 16,

        trigger: { ...defaultTrigger, ...(blockContent.trigger ?? {}) },
        frequency: blockContent.frequency ?? 'session',
        frequencyDays: blockContent.frequencyDays ?? 7,
        newVisitorsOnly: blockContent.newVisitorsOnly ?? false,
        countdown: blockContent.countdown ?? false,
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'feed',
      };
    },
    discountBlockClear: () => initialState,
    discountBlockUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    discountBlockUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    discountBlockUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    discountBlockUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const {
  discountBlockStore,
  discountBlockClear,
  discountBlockUpdateIsLoading,
  discountBlockUpdateIsActive,
  discountBlockUpdateBlockContent,
  discountBlockUpdateBlockDesign,
} = discountBlockSlice.actions;

export const selectDiscountBlockIsLoading = (state) => state.discountBlock.isLoading;
export const selectDiscountBlockIsActive = (state) => state.discountBlock.isActive;
export const selectDiscountBlockId = (state) => state.discountBlock.id;
export const selectDiscountBlockUID = (state) => state.discountBlock.uid;
export const selectDiscountBlockSID = (state) => state.discountBlock.sid;
export const selectDiscountBlockContent = (state) => state.discountBlock.blockContent;
export const selectDiscountBlockDesign = (state) => state.discountBlock.blockDesign;
export const selectDiscountBlockItemDesign = (state) => state.discountBlock.itemDesign;
export const selectDiscountBlockContainerDesign = (state) => state.discountBlock.containerDesign;

export default discountBlockSlice.reducer;
